module.exports = __webpack_public_path__ + "static/media/brush-stroke.60641093.svg";